import React from "react";

const Separator = ({ width = "1", height = "10", color = "#3B5998", link = "#", fill = "fillcolor" }) => (
  <a href={link} target="_blank" rel="noopener" className="dot-position">
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h1v10H0z" fill={fill} />
    </svg>
  </a>
);

export { Separator };
